import type { HaNTextRange } from "@lib/logic";

type HighlightedTextProps = {
  text: string;
  ranges: HaNTextRange[];
};

type TextPart = { start: number; text: string; isMatch: boolean };

/** The text in parts, with the matched ones marked. The ranges are sorted and don't overlap. */
const splitText = (text: string, ranges: HaNTextRange[]) => {
  const parts: TextPart[] = [];
  let end = 0;

  for (const [start, rangeEnd] of ranges) {
    if (start > end) parts.push({ start: end, text: text.slice(end, start), isMatch: false });

    parts.push({ start, text: text.slice(start, rangeEnd), isMatch: true });
    end = rangeEnd;
  }

  if (end < text.length) parts.push({ start: end, text: text.slice(end), isMatch: false });

  return parts;
};

// The parts of a name that match the search's query
export const HighlightedText = ({ text, ranges }: HighlightedTextProps) => {
  return (
    <>
      {splitText(text, ranges).map(part =>
        part.isMatch ? (
          <mark
            key={part.start}
            className="rounded-sm bg-energizing-yellow-500* text-inherit">
            {part.text}
          </mark>
        ) : (
          <span key={part.start}>{part.text}</span>
        ),
      )}
    </>
  );
};
